// extracted by mini-css-extract-plugin
export default {"faqBlock":"views-ContentPage-components-themes-PP-faqContainer__faqBlock--CQPPe"};